// Core
import React from 'react';
import { Box, Flex, Text, Divider, Grid, Image, useColorModeValue } from '@chakra-ui/react';

// Assets
import coin from 'assets/img/details/coin-1.png';
import crystal from 'assets/img/details/crystal-3.png';
import box from 'assets/img/details/box.png';
import ticket from 'assets/img/details/ticket.png';
import wheel from 'assets/img/details/wheel.png';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';

// Components
import Card from 'components/Card/Card';
import { StarsWhiteIcon } from '../../../components/Icons/Icons';

const GivenCard = () => {
	const titleBgColor = useColorModeValue('white', 'white'); 
	const titleTextColor = useColorModeValue('#0E1633', '#0E1633'); 
	const textColor = useColorModeValue('white', 'white'); 

    return (
    	<Card
    		mt={{base: '60px', md: '80px'}}
    		textAlign="center"
    		padding={{base: '24px 16px', lg: '32px'}}
    		border="1px solid rgba(255, 255, 255, 0.1))"
    		overflow="hidden"
    		className="animation-bap-given"
			background="linear-gradient(180deg, #099BFF 41.15%, #6CC3FF 100%)">
			<Text
				borderRadius="100px"
				fontSize={{base: '32px', md: '40px'}}
				fontStyle="italic"
				fontWeight="700"
				lineHeight="28px"
				letterSpacing="-1px"
				textTransform="uppercase"
			    margin="-11px auto 0 auto"
			    color={titleTextColor}
			    padding="16px"
				bg={titleBgColor}>We`ve given away</Text>
			<Flex gap="15px" justifyContent="center" mt="26px" alignItems="center">
				<StarsWhiteIcon fontSize="43px" overflow="visible" />
				<Text variant="header" fontSize={{base: '64px', lg: '80px'}} color={textColor}>$75</Text>
				<StarsWhiteIcon fontSize="43px" overflow="visible" />
			</Flex>
			<Text variant="header" fontSize={{base: '64px', lg: '80px'}} mt={{base: '-10px', lg: '-29px'}} color={textColor}>million</Text>
			<Text variant="header" fontSize="16px" maxW={{sm: '100%', md: '390px'}} 
				m={{base: '3px auto 270px auto', md: '3px auto 7px auto'}} color={textColor}>
				in prizes given away & we`ve
				generated our partners hundreds of 
				thousands in additional sales.</Text>
			<Lines className="abstract-lines" style={{zIndex: 1, left: '18%', transform: 'scale(1.5)'}} />
			<Box zIndex="2" position="absolute" bottom="0px" w="100%" left="0" className="animation-bap-given-scale1">
				<Image src={crystal} alt="crystal" position="absolute" left="-112px" bottom="127px" transform="rotate(334deg)" width="210px" />
				<Image src={crystal} alt="crystal" position="absolute" left="18px" bottom="132px" transform="rotate(335deg)" width="180px" />
				<Image src={crystal} alt="crystal" position="absolute" left="-83px" bottom="-32px" transform="rotate(32deg)" width="200px" zIndex="8" />
				<Image src={crystal} alt="crystal" position="absolute" left="41px" bottom="-36px" transform="rotate(37deg)" width="172px" zIndex="5" />
				<Image src={coin} alt="coin" position="absolute" left="-42px" bottom="23px" transform="rotate(31deg)" width="196px" zIndex="4" />
				<Image src={coin} alt="coin" position="absolute" left="130px" bottom="-85px" transform="rotate(8deg)" width="250px" zIndex="3" />
				<Image src={box} alt="box" position="absolute" left="80px" bottom="-15px" transform="rotateY(-180deg) rotate(-12deg)" width="220px" zIndex="2" />
			</Box>

			<Box zIndex="2" position="absolute" bottom="0px" w="100%" right="0" className="animation-bap-given-scale2">
				<Image src={crystal} alt="crystal" position="absolute" right="102px" bottom="-55px" width="174px" transform="rotate(-17deg)" zIndex="8" />
				<Image src={crystal} alt="crystal" position="absolute" right="-82px" bottom="31px" width="174px" transform="rotate(49deg)" zIndex="2" />
				<Image src={crystal} alt="crystal" position="absolute" right="-12px" bottom="72px" width="210px" transform="rotate(2deg)" zIndex="1"  />
				<Image src={crystal} alt="crystal" position="absolute" right="-34px" bottom="171px" width="165px" transform="rotate(-3deg)" zIndex="1"  />
				<Image src={coin} alt="coin" position="absolute" right="-66px" bottom="109px" width="155px" transform="rotate(31deg)" zIndex="1" />
				<Image src={ticket} alt="ticket" position="absolute" right="168px" bottom="-56px" width="170px" transform="rotate(67deg)" zIndex="7" />
				<Image src={wheel} alt="wheel" position="absolute" right="0px" bottom="-84px" width="380px" transform="rotate(10deg)" zIndex="5" />
			</Box>
    	</Card>
    );
};


export default GivenCard;